import { encryptPwd } from '@/hooks/usePwd'
import { http } from '../http'
import { URL } from './_constant'
/**
 * 验证-获取图形验证码
 */
export function API_VERIFY_PIC_CODE() {
  return http.post<ApiVerify.PicCodeRes>(URL.PIC_CODE)
}
/**
 * 验证-登录-手机号-验证码发送
 */
export function API_VERIFY_LOGIN_SMS_CODE(data: ApiVerify.LoginSmsCodeReq) {
  const { loginPassword, ..._data } = data
  return http.post<ApiVerify.SmsCodeRes>(URL.LOGIN_SMS_CODE, { ..._data, loginPassword: encryptPwd(loginPassword) })
}
/**
 * 验证-注册-手机号-验证码发送
 */
export function API_VERIFY_REGISTER_SMS_CODE(userPhone: string) {
  return http.post<ApiVerify.SmsCodeRes>(URL.REGISTER_SMS_CODE, { userPhone })
}
/**
 * 验证-修改手机号-验证码发送
 */
export function API_VERIFY_EDIT_PHONE_CODE(userPhone: string) {
  return http.post<ApiVerify.SmsCodeRes>(URL.EDIT_PHONE_CODE, { userPhone })
}

/**
 * 验证-登陆后验证码发送
 */
export function API_VERIFY_SMS_CODE() {
  return http.post<ApiVerify.SmsCodeRes>(URL.SMS_CODE)
}
/**
 * 验证-登录-邮箱-验证码发送
 */
export function API_VERIFY_LOGIN_EMAIL_CODE(email: string) {
  return http.post<ApiVerify.SmsCodeRes>(URL.LOGIN_EMAIL_CODE, { email })
}
/**
 * 验证-注册-邮箱-验证码发送
 */
export function API_VERIFY_REGISTER_EMAIL_CODE(email: string) {
  return http.post<ApiVerify.SmsCodeRes>(URL.REGISTER_EMAIL_CODE, { email })
}

/**
 * 验证-修改邮箱-验证码发送
 */
export function API_VERIFY_EDIT_EMAIL_CODE(email: string) {
  return http.post<ApiVerify.SmsCodeRes>(URL.EDIT_EMAIL_CODE, { email })
}
